import React, { Component } from "react";
import Header from "./Header.js";
import { Toast } from "primereact/toast";
import { Card } from "primereact/card";
import Footer from "./Footer.js";
import Server from "./Server.js";
import SearchFlight from "./travel/SearchFlight";
import { connect } from "react-redux";


class MainTravel extends Component {
  constructor(props) {
    super(props);
    this.Server = new Server();
    this.toast = React.createRef();

    this.state = {
      Autenticated: -1,
      username: null,
      loading: false,
      absoluteUrl: this.Server.getAbsoluteUrl(),
      url: this.Server.getUrl(),
    };
    

  }
  componentDidMount(){
    this.checkToken();
  }

  checkToken= ()=>{
      let SCallBack = (response) => {
        this.setState({
          Autenticated: 1,
          username: response.data.authData.username,
        });
      };
      let ECallBack = (error) => {
        this.setState({
          Autenticated: 0,
        });
      };
      this.Server.send("TravelApi/checktoken", { }, SCallBack, ECallBack);
  }

  render() {
    return (
      <div style={{ backgroundColor: "#fff" }}>
        <Toast
          ref={this.toast}
          position="bottom-left"
          style={{ fontFamily: "YekanBakhFaBold", textAlign: "right" }}
        />
        <Header Company={1} />
        <div className="row"></div>
        <div className="row" style={{ marginTop: 50 }}>
          <div className="col-12">
            <Card title="Title">
              <SearchFlight />
            </Card>
          </div>
        </div>
        {!this.state.loading ? (
          <Footer System={this.state.System} />
        ) : (
          <div style={{ textAlign: "center" }}></div>
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    systemId: state.systemId,
  };
};
export default connect(mapStateToProps)(MainTravel);
